exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".webinarRegistration{max-width:52rem;margin-left:auto;margin-right:auto;position:relative}.webinarRegistration .formOption{display:block;font-weight:400}.webinarRegistration .formOption input{margin-right:.5rem}.webinarRegistration .formOption:hover{cursor:pointer}.webinarRegistration .buttonSuccess{position:absolute;right:0;bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/support/webinar_registration.scss
// module id = 883
// module chunks = 0